import React from 'react';
import {
  Alert, Box, FormControl, InputLabel, LinearProgress, MenuItem, Select, Typography,
} from '@mui/material';
import * as ETVConstants from '../ETVConstants';

class LocationSelection extends React.Component {
  state = {
    list: [],
    isLoading: false,
    selected_location_id: this.props.cur_location_id || '',
    device_location_changed: false,
    saving: false,
    error: '',
  };

  componentDidMount() {
    this.loadLocations();
    this.props.onStateChange?.({ changed: false, saving: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user_id !== this.props.user_id) {
      this.loadLocations();
    }
    if (prevProps.cur_location_id !== this.props.cur_location_id) {
      this.setState({
        selected_location_id: this.props.cur_location_id || '',
        device_location_changed: false,
      });
    }
  }

  loadLocations = () => {
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const url = `${ETVConstants.getServerBase()}/xlocation?action=get_locations&user_id=${this.props.user_id}`;

    this.setState({ isLoading: true, error: '' });
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then(res => res.json())
      .then(
        (result) => {
          const list = Array.isArray(result.list) ? result.list.slice() : [];
          list.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
          if (list.length === 1) {
            const locationId = list[0].location_id;
            const changed = String(locationId) !== String(this.props.cur_location_id || '');
            this.setState({
              list,
              isLoading: false,
              selected_location_id: locationId,
              device_location_changed: changed,
            }, () => {
              this.props.onStateChange?.({ changed, saving: false });
              if (changed) this.setLocation();
            });
          } else {
            this.setState({ list, isLoading: false });
          }
        },
        (error) => this.setState({ list: [], isLoading: false, error: error.message || String(error) })
      );
  };

  selectLocationID = (locationId) => {
    const changed = String(locationId) !== String(this.props.cur_location_id || '');
    this.setState({
      selected_location_id: locationId,
      device_location_changed: changed,
      error: '',
    }, () => this.props.onStateChange?.({ changed, saving: false }));
  };

  setLocation = () => {
    if (!this.state.device_location_changed || !this.state.selected_location_id) return;

    this.setState({ saving: true, error: '' });
    this.props.onStateChange?.({ changed: true, saving: true });
    const url = `${ETVConstants.getServerBase()}/device_mgmt?action=set_location_id`
      + `&user_id=${this.props.user_id}`
      + `&device_id=${this.props.device_id}`
      + `&location_id=${this.state.selected_location_id}`;

    ETVConstants.sendCMDToServerListener(url, () => {
      this.setState({ saving: false, device_location_changed: false });
      this.props.onStateChange?.({ changed: false, saving: false });
      if (this.props.closeHook) this.props.closeHook();
    });
  };

  render() {
    const { list, isLoading, selected_location_id, error } = this.state;

    return (
      <Box sx={{ display: 'grid', gap: 2 }}>
        {isLoading && <LinearProgress />}
        {error && <Alert severity="error">{error}</Alert>}

        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {ETVConstants.trans('registered_locations')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            Select the building where this screen is installed.
          </Typography>
        </Box>

        <FormControl fullWidth>
          <InputLabel id="registered-locations-label">{ETVConstants.trans('registered_locations')}</InputLabel>
          <Select
            labelId="registered-locations-label"
            label={ETVConstants.trans('registered_locations')}
            value={selected_location_id}
            disabled={list.length === 1}
            onChange={(event) => this.selectLocationID(event.target.value)}
          >
            {list.map(location => (
              <MenuItem key={location.location_id} value={location.location_id}>
                {location.name} - {location.address}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  }
}

export default LocationSelection;
